import { useRef, useState } from "react";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/airbnb.css";

import { CalendarIcon, TimeIcon } from "components/Icons";
import FormField from "./FormField";
import { classNames, colors } from "tools/ui";
import upStore from "store/upStore";

const style =
  "outline-none w-full py-2 px-2 rounded-md wrap h-[38px] events-pointer-none";
const styleIcon =
  "text-start mr-1 h-6 w-6 my-auto text-zinc-600 fill-current max-md:hidden";
const styleDiv =
  "flatpickr h-10 flex outline-none border border-slate-300 rounded-md focus:border-sky-400 fill-current";

function DatetimeField(props) {
  const { field, attrs, data } = props;
  const { readOnly, name, noCalendar } = field;
  const { level } = attrs;
  const [state, setState] = useState(null);
  const localDate = data?.value !== "" ? new Date(data?.value) : null;
  const fp = useRef(null);

  function openCalendar(e) {
    // is necesary for use icon calendar
    e.preventDefault();
    e.stopPropagation();
    if (!readOnly && fp.current) {
      fp.current.flatpickr.open();
    }
  }

  function handleDate(rangeDates) {
    if (rangeDates.length === 0) return;
    const value = rangeDates[0];
    data.value = value;
    upStore(level, {
      fieldName: name,
      value: value,
      field: field,
    });
  }

  const disable = readOnly ? "pointer-events-none" : "";
  const color = readOnly ? colors["readOnly"] : "";

  const options = {
    enableTime: true,
    dateFormat: noCalendar ? "H:i" : "Y-m-d  |  H:i",
    noCalendar: noCalendar ?? false,
    disableMobile: true,
  };

  const displayValue =
    noCalendar && localDate
      ? new Date(localDate).toLocaleTimeString("es-CO", {
          hour: "2-digit",
          minute: "2-digit",
        })
      : localDate;

  const Icon = noCalendar ? TimeIcon : CalendarIcon;

  return (
    <FormField {...field}>
      <div className={classNames(styleDiv, color, disable)}>
        <Flatpickr
          ref={fp}
          options={options}
          className={classNames(style, color)}
          value={localDate}
          onChange={handleDate}
          onClick={openCalendar}
          onFocus={openCalendar}
        />
        <Icon
          onClick={openCalendar}
          className={classNames(styleIcon, color)}
          aria-hidden="true"
        />
      </div>
    </FormField>
  );
}

export default DatetimeField;
